import { deleteObject, getDownloadURL, listAll, ref as firebaseRef } from "firebase/storage";
import { useConfig } from "~/composables/useConfig";

const { TITLE_IMAGE_FILE_TYPE, TITLE_IMAGE_NAME, PROFILE_IMAGE_NAME } = useConfig();

export const getImagesInPath = (path) => {
  const storage = useNuxtApp().$imageStorage;
  const storageRef = firebaseRef(storage, path);
  return listAll(storageRef).then((res) => res.items);
};

export const getImageInPathSegments = (pathSegments) => {
  const path = pathSegments.join("/");
  const storage = useNuxtApp().$imageStorage;
  const storageRef = firebaseRef(storage, path);

  return new Promise((resolve, reject) =>
    getDownloadURL(storageRef)
      .then((url) => {
        resolve(url);
      })
      .catch((error) => {
        if (error.code === "storage/object-not-found") {
          resolve(null);
        } else {
          reject(error);
        }
      }));
};

export const countImagesInPath = (path) => getImagesInPath(path).then((items) => items.length);
export const countImagesInPathSegments = (pathSegments) => countImagesInPath(pathSegments.join("/"));

export const deleteImageInPath = (imagePath) => {
  const careDayImagePath = `careday/${imagePath}`;
  const storage = useNuxtApp().$imageStorage;
  const storageRef = firebaseRef(storage, careDayImagePath);
  return deleteObject(storageRef);
};

const deleteImageInFacilityPath = (imagePath) => {
  const path = `facility/${imagePath}`;
  const storage = useNuxtApp().$imageStorage;
  const storageRef = firebaseRef(storage, path);
  return deleteObject(storageRef);
};

export const deleteEmployeeImage = (imagePath) => {
  const pathWithFileName = `${imagePath}/${PROFILE_IMAGE_NAME}.png`;
  return deleteImageInFacilityPath(pathWithFileName);
};

export const deleteTitleImage = (imagePath) => {
  const pathWithFileName = `${imagePath}/${TITLE_IMAGE_NAME}${TITLE_IMAGE_FILE_TYPE}`;
  return deleteImageInPath(pathWithFileName);
};

export const deleteEmployeeProfileImage = (imagePath) => {
  const pathWithFileName = `${imagePath}/${PROFILE_IMAGE_NAME}${TITLE_IMAGE_FILE_TYPE}`;
  return deleteImageInPath(pathWithFileName);
};

